export function cloneDeep(value: any): any {
  if (value !== null && typeof value === 'object') {
    let newValue: { [index: string]: any } = {};
    if (Array.isArray(value)) {
      newValue = [];
      for (let i = 0; i < value.length; i++) {
        newValue[i] = cloneDeep(value[i]);
      }
    } else if (value instanceof Date) {
      newValue = new Date(value.getTime());
    } else {
      newValue = {};
      const keys = Object.keys(value);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        newValue[key] = cloneDeep(value[key]);
      }
    }
    return newValue;
  }
  return value;
}
